import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Params, ResolveFn, Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { SimulationEngineResponse } from '../api/simulator-engine.api';
import { QuestionFacade } from '../facade/question.facade';
import { SIMULATION_LOAD_RULES } from './simulation-load.rules';
import { State } from '../state/state';

export interface ResolutionContext {
  facade: QuestionFacade;
  router: Router;
  stateSnapshot: State;
  queryParams: Params;
}

export const resultPageResolver: ResolveFn<boolean | SimulationEngineResponse> = (
  route: ActivatedRouteSnapshot,
): Observable<boolean | SimulationEngineResponse> => {
  const facade = inject(QuestionFacade);
  const router = inject(Router);

  const ctx: ResolutionContext = {
    facade,
    router,
    stateSnapshot: facade.state$.value,
    queryParams: route.queryParams,
  };

  const rule = SIMULATION_LOAD_RULES.find((r) => r.canHandle(ctx));
  if (!rule) {
    // This should never happen because RedirectToBeginning is a fallback rule that always matches.
    throw new Error('No matching SimulationLoad rule found. Please ensure a fallback rule is present in RULES.');
  }
  return rule.execute(ctx).pipe(catchError((err) => throwError(() => err)));
};
